module.exports = __webpack_public_path__ + "static/img/tag_list_hwbz14@2x.9f6c7729.png";